<template>
  <sound-cloud
    :track="source"
    :mini="false"
  />
</template>

<script>
import SoundCloud from 'vue-soundcloud-player';

export default {
  components: {
    SoundCloud,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
  },
};
</script>
